import { type MetaFunction } from '@remix-run/node'
import ontario from './ontario.png'

export const meta: MetaFunction = () => [
	{ title: 'Ontario Insurance Company' },
	{
		name: 'description',
		content: 'We offer insurance from Ontario Insurance Company.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Ontario</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={ontario} alt="Ontario Insurance Company" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					It was started in 1877 as the Ontario County Patron's Fire Relief
					Association.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Ontario has products for Homeowners, Farmowners, Landlords, Business
					Owners, and Contractors.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://ontarioinsco.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://ontarioinsco.com/ (opens in a new tab)
					</a>
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Ontario Online Payment"
						href="https://pay.xpress-pay.com/org/2EB7930D6637416"
						target="_blank"
						rel="noopener noreferrer"
					>
						https://pay.xpress-pay.com/org/2EB7930D6637416 (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					28 Canandaigua Street
					<br />
					Shortsville, New York 14548-9762
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Ontario Insurance Company
					<br />
					28 Canandaigua Street
					<br />
					Shortsville, New York 14548-9762
				</p>
			</section>
		</main>
	)
}
